export var BILLING_PAYMENT_TYPE_CODES = {
  ADJUSTMENT: 3,
  ALL: 0,
  CREDIT_NOTE: 5,
  DEBIT_NOTE: 6,
  INVOICE_SUMMARY: 1,
  PAYMENT: 2
};
export var INVOICE_TYPE = {
  PERIODIC: 1,
  ONDEMAND: 2
};
export var ADJUSTMENT_REASON_TYPE_CODE = 391;
export var ADJUSTMENT_TYPE_TYPE_CODE = 390;
export var NA = 'N/A';
export var PAYMENT_TYPE_CODES = {
  POINT_OF_SALE: 20
};
export var INVOICE_ITEM_TYPES = {
  INVOICE_ITEM: 1,
  TAX_ITEM: 2,
  USAGE_SUMMARY: 3,
  BILLING_FEES: 4,
  LATE_PAYMENT_FEE: 5
};
export var ACCOUNTING_METHODS_NAMES = {
  BALANCE_FORWARD: 1,
  OPEN_INVOICE: 2
};
export var MISC_ADJUSTMENT_TYPE_CODE = 1002;
export var CREDIT_NOTE_TYPE_CODE = 1006;
export var TAX_TYPE = {
  INCLUSIVE: 1,
  EXCLUSIVE: 2
};